var map = {
  "./km.json": [
    "686034",
    "678663"
  ],
  "./ru.json": [
    "693770",
    "776742"
  ],
  "./bg.json": [
    "441278",
    "468677"
  ],
  "./el.json": [
    "221568",
    "885329"
  ],
  "./en-pt.json": [
    "789437",
    "520430"
  ],
  "./ja.json": [
    "800043",
    "163028"
  ],
  "./sv.json": [
    "766207",
    "97545"
  ],
  "./sr.json": [
    "396807",
    "980309"
  ],
  "./uk.json": [
    "793622",
    "921098"
  ],
  "./zh-hans.json": [
    "442317",
    "78373"
  ],
  "./fr.json": [
    "552086",
    "896084"
  ],
  "./as.json": [
    "986400",
    "849523"
  ],
  "./gu.json": [
    "475486",
    "658796"
  ],
  "./kk.json": [
    "67860",
    "677574"
  ],
  "./nb.json": [
    "346239",
    "932865"
  ],
  "./uz.json": [
    "591305",
    "413421"
  ],
  "./ky.json": [
    "881863",
    "407166"
  ],
  "./pl.json": [
    "22208",
    "992113"
  ],
  "./ro.json": [
    "291200",
    "938579"
  ],
  "./ka.json": [
    "188951",
    "313306"
  ],
  "./hu.json": [
    "948517",
    "904006"
  ],
  "./hy.json": [
    "756667",
    "650963"
  ],
  "./de.json": [
    "394714",
    "55900"
  ],
  "./pt-pt.json": [
    "688901",
    "493352"
  ],
  "./vi.json": [
    "615086",
    "272730"
  ],
  "./tr.json": [
    "733336",
    "18388"
  ],
  "./da.json": [
    "250336",
    "418402"
  ],
  "./kn.json": [
    "297849",
    "467023"
  ],
  "./id.json": [
    "901284",
    "410936"
  ],
  "./lt.json": [
    "730558",
    "591652"
  ],
  "./lv.json": [
    "185928",
    "103310"
  ],
  "./es.json": [
    "109621",
    "860085"
  ],
  "./ko.json": [
    "345984",
    "990410"
  ],
  "./bn.json": [
    "715457",
    "417682"
  ],
  "./cs.json": [
    "346696",
    "468076"
  ],
  "./boxes.json": [
    "985361",
    "656175"
  ],
  "./my.json": [
    "189316",
    "537530"
  ],
  "./sk.json": [
    "272399",
    "265647"
  ],
  "./nl.json": [
    "251619",
    "700766"
  ],
  "./az.json": [
    "868004",
    "182460"
  ],
  "./accents.json": [
    "444229",
    "118900"
  ],
  "./pa.json": [
    "174790",
    "139238"
  ],
  "./pt.json": [
    "389984",
    "759256"
  ],
  "./extra.json": [
    "991387",
    "228549"
  ],
  "./it.json": [
    "81071",
    "592317"
  ],
  "./hi.json": [
    "682107",
    "187627"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 777667;
module.exports = webpackAsyncContext;
